import React, { useContext, useEffect } from 'react';
import { ChartContainer } from './PPAInsightPieCharts.style';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { AppContext } from '../../../../../Context/AppContext';
import { getLongVsShortTermData } from '../../PpaInsightUtils';
import { IppaInsightLongVsShortTermData } from '../../../../../Types/types';
import { PPAInsightNoRecords } from '../../PPAInsightNoRecordsPage/PPAInsightNoRecords';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

export const PPAInsightLongVsShortTermPieChart = () => {
  const { state: ppaInsightState, dispatch: ppaInsightDispatch } =
    useContext(AppContext).ppaInsight;
  useEffect(() => {
    getLongVsShortTermData(ppaInsightDispatch, ppaInsightState.filteredValues);
  }, [ppaInsightState.filteredValues]);

  const item: IppaInsightLongVsShortTermData = ppaInsightState.longVsShortTermData;

  const chartData = [
    {
      name: 'Long-Term',
      value: item.longTermTotal,
    },
    {
      name: 'Short Term',
      value: item.shortTermTotal,
    },
  ];

  return (
    <ChartContainer>
      {ppaInsightState.longVsShortTermData.longTermTotal === 0 && <PPAInsightNoRecords />}
      {ppaInsightState.longVsShortTermData.longTermTotal !== 0 && (
        <div style={{ width: '100%', height: '400px' }}>
          <h3 style={{ textAlign: 'left', marginBottom: '0.5rem' }}>Long-Term vs Short-Term Deals</h3>
          <p style={{ textAlign: 'left', fontSize: '0.875rem', color: '#666', marginBottom: '1rem' }}>
            A summary to compare Long-term vs short-term deals
          </p>
          <ResponsiveContainer width="100%" height="80%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={true}
                label={({ name, percent }) => `${name}: ${((percent ?? 0) * 100).toFixed(0)}%`}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="top" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </ChartContainer>
  );
};
